var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.507812,
    y: 0.453125,
    width: 61.2038,
    height: 61.2038,
    rx: 10.2006,
    fill: "#0B60D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1175 34.454V27.6536C48.1175 21.2421 48.1175 18.0363 46.1257 16.0445C44.134 14.0527 40.9281 14.0527 34.5167 14.0527H31.1165C24.705 14.0527 21.4992 14.0527 19.5074 16.0445C17.5156 18.0363 17.5156 21.2421 17.5156 27.6536V34.454C17.5156 40.8654 17.5156 44.0713 19.5074 46.063C21.4992 48.0548 24.705 48.0548 31.1165 48.0548H34.5167C40.9281 48.0548 44.134 48.0548 46.1257 46.063C48.1175 44.0713 48.1175 40.8654 48.1175 34.454Z",
    stroke: "white",
    strokeWidth: 2.55016
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2175 20.8535H14.1172M19.2175 31.0541H14.1172M19.2175 41.2548H14.1172",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4723 22.5527H33.6719M37.0721 29.3532H33.6719",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0234 48.0548V14.0527",
    stroke: "white",
    strokeWidth: 2.55016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.09ff8eb665ce209f197255aef118ec06.svg";
export { ForwardRef as ReactComponent };